<template>
  <span></span>
</template>

<script setup>
/**
 * HACK:
 * This empty script is required to make nested components work in Vue 3
 * while keeping compatibility with Vue 2 intact.
 */
</script>

<script>
import eventBus from '@loreal/eventbus-js';

export default {
  name: 'rfp-ratings-tagging-brand',
  props: {
    pageCategorys: {
      type: String,
      default: 'No page catogery',
    },
  },
  data() {
    return {
      overallRatingReview: 0,
    };
  },
  created() {
    /* istanbul ignore next */
    eventBus.on('pageCategoryss', () => {
      eventBus.emit('pageCategory', this.pageCategorys);
    });
    /* istanbul ignore next */
    eventBus.emit('pageCategory', this.pageCategorys);
  },
};
</script>
